import React, { useEffect, useState } from "react";
import BannerSection from "../QuinceneraPage/qbannerSection";
import WelcomeSection from "../QuinceneraPage/qWelcomeSection";
import { useParams } from "react-router-dom";
import Features from "./features";
import Layout from "./layout";
import VirtualTour from "./virtualTour";
import Testimonial from "./testimonial";
import Videos from "./videos";
import { corefetch } from "../../../Util/axios_core_helper";
import Gallery from "./fGallery";
import ServiceSection from "../QuinceneraPage/serviceSection";
import Amenities from "../QuinceneraPage/amenities";

const FacilityMain = () => {
  const { facilityId } = useParams();
  const [ballroomId, setBallroomId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBallroomId = async () => {
      try {
        const result = await corefetch(
          `Facility/GetDisplayedinIDbyFailityID?facilityId=${facilityId}`
        );
        setBallroomId(result);
      } catch (error) {
        console.error("Error fetching Ballroom ID:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBallroomId();
  }, [facilityId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!ballroomId) {
    return null;
  }

  return (
    <>
      <BannerSection id={ballroomId} />
      <WelcomeSection id={ballroomId} />
      <Features id={ballroomId} />
      <ServiceSection id={ballroomId}/>
      <Layout id={ballroomId} />
      <VirtualTour id={ballroomId} />
      <Amenities id={ballroomId}/>
      <Gallery id={ballroomId} facID={facilityId} />
      <Testimonial id={ballroomId} />
      <Videos id={ballroomId} />
    </>
  );
};

export default FacilityMain;
